import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const Home = () => {
  let [user] = useState(JSON.parse(localStorage.getItem("user")));
  return (
    <>
      <div className="row">
        {user.role === "Editor" || user.role === "Admin" ? (
          <div className="col-md-4 col-6">
            <>
              <NavLink
                to="/ideas"
                className="btn btn-warning mg-y-8 btn-block ion-flash"
              >
                {" "}
                View Pending Ideas
              </NavLink>
              <br />
              <NavLink
                to="/breakings"
                className="btn btn-warning mg-y-8 btn-block ion-flash"
              >
                {" "}
                View Breakings
              </NavLink>
              <br />
              <NavLink
                to="/posts"
                className="btn btn-warning mg-y-8 btn-block ion-flash"
              >
                {" "}
                View Posts
              </NavLink>
              <br />
              <NavLink
                to="/Photogallery"
                className="btn btn-warning mg-y-8 btn-block ion-flash"
              >
                {" "}
                View Photo Gallery
              </NavLink>
              <br />
              <NavLink
                to="/Videostory"
                className="btn btn-warning mg-y-8 btn-block ion-flash"
              >
                {" "}
                View Video Stories
              </NavLink>
              <br />{" "}
              <NavLink
                to="/assignments/add-assignment"
                className="btn btn-primary mg-y-8 btn-block ion-document"
              >
                {" "}
                Add Assignment
              </NavLink>
              <br />
            </>
          </div>
        ) : (
          ""
        )}

        <div className="col-md-4 col-6">
          <NavLink
            to="/ideas/add-idea"
            className="btn btn-primary mg-y-8 btn-block ion-ios-lightbulb-outline"
          >
            {" "}
            Ideas
          </NavLink>
		  <br />
		  <NavLink
            to="/posts/add-post"
            className="btn btn-info mg-y-8 btn-block ion-chatbubble-working"
          >
            {" "}
            New Post
          </NavLink>
          <br />
          <NavLink
            to="/s3media"
            className="btn btn-primary mg-y-8 btn-block ion-images"
          >
            {" "}
            Upload Media
          </NavLink>
		  <br />
          <a
            href="https://dlgoo6udmxfsz.cloudfront.net/mojo/mojo.mp4"
			target="_blank"
            className="btn btn-warning mg-y-8 btn-block ion-ios-lightbulb-outline"
          >
            {" "}
            खबर पोस्ट करने का तरीका, वीडियो में देखें
          </a>
		  <br />
          <a
            href="https://dlgoo6udmxfsz.cloudfront.net/mojo/mojo.pdf"
			target="_blank"
            className="btn btn-warning mg-y-8 btn-block ion-ios-lightbulb-outline"
          >
            {" "}
            Tutorial PDF
          </a>
      
          
        </div>
      </div>
    </>
  );
};
export default Home;
